module.exports = __webpack_public_path__ + "img/MapPicsMarshlands.3612d177.webp";